<template>
  <div>
    <div class="jumbotron">
      <div class="mask"></div>
      <b-row class="mx-auto" style="max-width: 1460px">
        <HomeText></HomeText>
        <b-col sm="7">
          <Accredits></Accredits>
          <div class="text-right mt-5">
            <router-link to="/compliance" class="text-white">compliance</router-link>
          </div>
        </b-col>
      </b-row>
    </div>
    <HomeSteps></HomeSteps>
  </div>
</template>
<script>
import util from "@/mixing/util";
import Accredits from "@/components/CardAccreditation";
import HomeText from "@/components/HomeText";
import HomeSteps from "@/components/HomeSteps";

export default {
  components: { Accredits, HomeText, HomeSteps },
  mixins: [util],
  created(){
    if(localStorage.dest_lang)
      localStorage.removeItem('dest_lang');
  }
};
</script>
<style scoped>
.jumbotron {
  background-image: url("/img/bg-home.png");
}
.mask {
  position: absolute;
  background-color: #463a21;
  opacity: 0.4;
  width: 100%;
  height: 100%;
}
</style>
